module.exports = __webpack_public_path__ + "64ddbf547c1d9759cea73b59bd64727f.jpg";